import _asyncToGenerator from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "D:\\progect\\guowai\\ex_express_web\\node_modules\\core-js\\modules\\es.array.iterator.js";
import "D:\\progect\\guowai\\ex_express_web\\node_modules\\core-js\\modules\\es.promise.js";
import "D:\\progect\\guowai\\ex_express_web\\node_modules\\core-js\\modules\\es.object.assign.js";
import "D:\\progect\\guowai\\ex_express_web\\node_modules\\core-js\\modules\\es.promise.finally.js";
import "regenerator-runtime/runtime.js";
import Vue from 'vue';
import i18n from './i18n';
import App from './App';
import store from '@/store';
import d2Admin from '@/plugin/d2admin';
import router, { constantRoutes } from './router';
import './permission';
import VCharts from 'v-charts';
Vue.use(d2Admin);
Vue.use(VCharts);
new Vue({
  router: router,
  store: store,
  i18n: i18n,
  render: function render(h) {
    return h(App);
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 处理路由 得到每一级的路由设置
              _this.$store.commit('d2admin/page/init', constantRoutes); // 加载接口配置


              _context.next = 3;
              return _this.$store.dispatch('d2admin/api/load');

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 展示系统信息
              _this2.$store.commit('d2admin/releases/versionShow'); // 用户登录后从数据库加载一系列的设置


              _context2.next = 3;
              return _this2.$store.dispatch('d2admin/sys/load');

            case 3:
              // 获取并记录用户 UA
              _this2.$store.commit('d2admin/ua/get'); // 初始化全屏监听


              _this2.$store.dispatch('d2admin/fullscreen/listen');

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
}).$mount('#app');